module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/65be0c15b22044e29d75368efe3c0203.gif";